import * as _ from "lodash";
import * as z from "../../framework";

export const rights: string[] = [];
export function userHasRight(rightName: string): boolean {
  return _.includes(z.user.companyData.Rights, rightName);
}
